class GeneralHelper {
    /**
     * alternative to lodash throttle
     * @param func
     * @param timeFrame
     * @returns {(function(...[*]): void)|*}
     */
    static throttle(func, timeFrame) {
        let lastTime = 0;
        return (...args) => {
            const now = new Date();
            if (now - lastTime >= timeFrame) {
                func(...args);
                lastTime = now;
            }
        };
    }

    /**
     * scale a number from an interval [inMin, inMax] to a new interval [outMin, outMax]
     * @param num
     * @param inMin
     * @param inMax
     * @param outMin
     * @param outMax
     * @returns {*}
     */
    static scale(num, inMin, inMax, outMin, outMax) {
        return ((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
    }

    /**
     * return height of page-header and 0 if no page-header exists
     * @returns {number|number}
     */
    static getPageHeaderHeight() {
        const header = document.querySelector('.page-header');

        return header ? header.getBoundingClientRect().height : 0;
    }

    static getPageLangCountry() {
        const langAttribute = document.documentElement.lang;
        let lang = 'de';
        let country = 'de';

        if (langAttribute.includes('fr-CH')) {
            lang = 'fr';
            country = 'ch';
        }
        if (langAttribute.includes('en-US')) {
            lang = 'en';
        }
        if (langAttribute.includes('nl-NL')) {
            lang = 'nl';
            country = 'nl';
        }
        if (langAttribute.includes('de-AT')) {
            country = 'at';
        }
        if (langAttribute.includes('de-CH')) {
            country = 'ch';
        }

        return { country, lang };
    }
}

export default GeneralHelper;
